$(function () {
	$('#hide_old').click(function () {
		$('#hide_old_form').submit();
	});

	if (!$('#stop').attr('disabled')) {
		$('#stop').datepicker({
			showOn: "button",
			buttonImage: "/_moya/icons/Calendar.png",
			buttonImageOnly: true,
			dateFormat: "dd.mm.yy 00.00",
			changeMonth: true,
			changeYear: true,
			onClose: function (dateText, inst) {
				var val = inst.input.val();
				if ($("#start").val().length < 1) {
					$("#start").val(inst.input.val());
				}
			}
		});
	}

	if (!$('#start').attr('disabled')) {
		$('#start').datepicker({
			showOn: "button",
			buttonImage: "/_moya/icons/Calendar.png",
			buttonImageOnly: true,
			dateFormat: "dd.mm.yy 00.00",
			changeMonth: true,
			changeYear: true,
			onClose: function (dateText, inst) {
				var val = inst.input.val();
				if ($("#stop").val().length < 1) {
					$("#stop").val(inst.input.val());
				}
			}
		});
	}

	if (!$('#until').attr('disabled')) {
		$('#until').datepicker({
			showOn: "button",
			buttonImage: "/_moya/icons/Calendar.png",
			buttonImageOnly: true,
			dateFormat: "dd.mm.yy 00.00",
			changeMonth: true,
			changeYear: true
		});
	}

	$('#fieldset-roomInformation').append('<div id="bookingcheck"></div>');
	$('#stop, #start, #rooms').bind('change', bkPostData);
	bkPostData();

	function bkPostData() {
		var stop = $('#stop').val(),
			start = $('#start').val(),
			rooms = $('#rooms').val(),
			$bookingForm = $('#booking-form'),
			id = 0;

		if ($bookingForm.length && stop && start && rooms) {
			id = $bookingForm.attr('booking-id');
			if (stop.length && start.length && rooms != null) {
				jQuery.ajax({
					type: 'POST',
					url: '/' + moya.division + "/moya/bk/booking/ajax_check",
					data: {
						'start': start,
						'stop': stop,
						'rooms': [rooms],
						'id': id
					},
					success: bkShowResponse
				});
			}
		}
	}

	function bkShowResponse(data) {
		var div = $('#bookingcheck');
		var html = '';
		var json = eval(data);

		if (undefined != json[0] && json[0].id > 0) {
			//found entry
			html = 'Salurinn ' + json[0].title + ' er bókaður á þessum tíma.';
			div.removeClass('safe').addClass('error').html(html);
		}
		else {
			html = 'Engar bókanir fundust með þessi skilyrði';
			div.removeClass('error').addClass('safe').html(html);
		}

	}
});